import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports',
  templateUrl: './helpbutton-reports.component.html',
  styleUrls: ['./helpbutton-reports.component.scss']
})
export class HelpbuttonReportsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
